import React, { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const LaInformationForm = ({ navigation, route }): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        maritalStatuses
    } = params

    const intializeStore = useInitializeStore()
    const { loading, postlaonline, getmodetails } = useFormsStore()

    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const options1 = [
        { key: "1", value: 'No standard deduction' },
        { key: "2", value: 'Single or married filing separate' },
        { key: "3", value: 'Married filing jointly, Head of household, or qualifying surviving spouse' }
    ]




    const handlesubmit = async (values) => {
        const data = {
            essUserKey: intializeStore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            blockAexemptions: values.blockAexemptions,
            // blockBdependents: Number(values.dependents),
            totalBlockAexemptions: Number(values.blockAexemptions),
            // totalBlockBdependents: Number(values.dependents),
            amount: Number(values.amount),
            maritalStatus: options1[values.blockAexemptions].key,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: mode == "online" ? true : false
        }
        console.log("data", data);

        const response: any = await postlaonline(data)
        if (response?.success === true) {
            if (mode === 'online') {
                navigation.navigate('LAInformationOnline', {
                    essUserOnBoardingKey,
                    essUserOnBoardingFormKey,
                    values,
                    completeOnline: mode === 'upload' ? false : true
                })
            } else {
                await Toast.show({
                    type: 'success',
                    position: 'bottom',
                    text1: response?.message,
                    visibilityTime: 3000,
                    autoHide: true,
                    topOffset: 60,
                    onHide: () => {
                        navigation.replace('OnboardingForms')
                    }
                })
            }
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    const intialValues = {
        // dependents: '',
        blockAexemptions: '',
        amount: ''
    }
    const w4schema = () => {
        const baseSchema = {
            // dependents: yup.string().required('Dependents is a required field'),
            blockAexemptions: yup.string().required('Filing status is a required field'),
            amount: yup.string().required('Amount is a required field')
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'LA Withholding Taxation'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        await handlesubmit(values)
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '35%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.blockAexemptions
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('blockAexemptions', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.blockAexemptions &&
                                            props.errors.blockAexemptions && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.blockAexemptions}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {/* <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '55%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter the number of dependents *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '35%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.dependents}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('dependents')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.dependents && props.errors.dependents && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.dependents}
                                            </Text>
                                        )}
                                    </View>
                                </View> */}
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter any increase or decrease in the amount of tax to be withheld each pay period. Decreases should be indicated as a negative amount and cannot result in an amount less than zero to be withheld each pay period *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '35%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.amount}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^-?\d*$/.test(text)) {
                                                    props.handleChange('amount')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.amount && props.errors.amount && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.amount}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                {/* <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Martial Status *'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            title="Martial Status"
                                            options={maritalStatuses}
                                            selectedOption={mapSelectValue(
                                                maritalStatuses,
                                                props.values.maritalStatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('maritalStatus', option - 1)

                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.maritalStatus && props.errors.maritalStatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.maritalStatus as string}
                                            </Text>
                                        )}
                                    </View>
                                </View> */}

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>

                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}
export default LaInformationForm
